export const getHighlightedText = (text: string, highlight: string) => {
  // Split on highlight term and include term into parts, ignore case
  if (text) {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {" "}
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase()
                ? { background: "#FFF01F" }
                : {}
            }
          >
            {part}
          </span>
        ))}{" "}
      </span>
    );
  } else {
    return <span />;
  }
};
